import React from 'react';
import { Box, LinearProgress, Modal, Typography } from '@mui/material';

/**
 * UploadProgressDialog - Reusable progress dialog for file uploads.
 *
 * Props:
 *   open       - boolean - whether the dialog is shown
 *   progress   - number  - 0-100 percentage. Pass null/undefined/-1 for indeterminate mode
 *   label      - string  - main label (e.g., "Uploading document...", "Saving...")
 *   subLabel   - string  - secondary text (default: "Please don't close this window")
 */
const UploadProgressDialog = ({ open, progress, label, subLabel }) => {
    if (!open) return null;

    const isDeterminate = typeof progress === 'number' && progress >= 0;

    return (
        <Modal open={open} disableEscapeKeyDown disableAutoFocus>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '24vw',
                    minWidth: '320px',
                    backgroundColor: '#fff',
                    borderRadius: 1,
                    boxShadow: 24,
                    p: 3,
                    outline: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography sx={{ fontSize: '1vw', fontWeight: 600, color: '#04B7B1', mb: 2 }}>
                    {label || 'Uploading...'}
                </Typography>

                <Box sx={{ width: '100%' }}>
                    <LinearProgress
                        variant={isDeterminate ? 'determinate' : 'indeterminate'}
                        value={isDeterminate ? progress : undefined}
                        sx={{
                            height: 10,
                            borderRadius: 5,
                            '& .MuiLinearProgress-bar': { backgroundColor: '#04B7B1' },
                        }}
                    />
                </Box>

                <Typography sx={{ fontSize: '0.9vw', color: '#444', mt: 1.5, fontWeight: 500 }}>
                    {isDeterminate ? `${progress}%` : 'Please wait...'}
                </Typography>

                <Typography sx={{ fontSize: '0.75vw', color: '#888', mt: 1 }}>
                    {subLabel || "Please don't close this window"}
                </Typography>
            </Box>
        </Modal>
    );
};

export default UploadProgressDialog;
